import React from 'react'
import { RealEstateFeatures } from '../../../../../@types/types'
import { estateFeatures } from '../../../../../components/pages/insertionPage/screens/otherFacilities/wrapper/otherFacilitiesFieldsWrapper'
import { BuildingTypeOption } from '../../../../../@types/dropdown-types'

export const tenantHouseRentEstateFeaturesList = [
  RealEstateFeatures.EQUIPPED_KITCHEN,
  RealEstateFeatures.GUEST_TOILET,
  RealEstateFeatures.BASEMENT,
  RealEstateFeatures.STEPLESS_ACCESSIBLE,
  RealEstateFeatures.FLAT_SHARE_SUITABLE,
]

export const tenantHouseRentEstateFeatures = () => estateFeatures(tenantHouseRentEstateFeaturesList)

export const createTenantHouseRentEstateFeaturesForWebView = (label: React.ReactNode, className: string) =>
  estateFeatures(tenantHouseRentEstateFeaturesList, label, className)

export const tenantHouseRentBuildingTypeOptions = [
  BuildingTypeOption.SINGLE_FAMILY_HOUSE,
  BuildingTypeOption.MID_TERRACE_HOUSE,
  BuildingTypeOption.END_TERRACE_HOUSE,
  BuildingTypeOption.MULTI_FAMILY_HOUSE,
  BuildingTypeOption.BUNGALOW,
  BuildingTypeOption.FARMHOUSE,
  BuildingTypeOption.SEMIDETACHED_HOUSE,
  BuildingTypeOption.VILLA,
  BuildingTypeOption.CASTLE_MANOR_HOUSE,
  BuildingTypeOption.SPECIAL_REAL_ESTATE,
  BuildingTypeOption.OTHER,
]
